import { Box, useTheme } from '@mui/material';
import { useRef } from 'react';
import { FileInputClasses, useNotify, useTranslate } from 'react-admin';
import { ImageInput, ImageInputProps } from '../../../../components/inputs/ImageInput';

export const OVERLAY_IMAGE_ACCEPT = {
  'image/png': ['.png'],
  'image/jpeg': ['.jpg', '.jpeg'],
};
export const OVERLAY_IMAGE_ACCEPT_WITH_PDF = {
  ...OVERLAY_IMAGE_ACCEPT,
  'application/pdf': ['.pdf'],
};

type OverlayImageInputProps = ImageInputProps & {
  allowPdf?: boolean;
};

export const OverlayImageInput = ({ allowPdf = false, ...props }: OverlayImageInputProps) => {

  const translate = useTranslate();
  const notify = useNotify();
  const theme = useTheme();
  const rootRef = useRef<HTMLDivElement>(null);

  const openFilePicker = () => {

    rootRef.current
      ?.querySelector<HTMLInputElement>('input[type="file"]')
      ?.click();

  };

  return (
    <Box
      ref={rootRef}
      sx={{
        [`&:has(.previews *) .${FileInputClasses.dropZone}`]: {
          position: 'absolute',
          width: 1,
          height: 1,
          padding: 0,
          margin: -1,
          overflow: 'hidden',
          clip: 'rect(0, 0, 0, 0)',
          whiteSpace: 'nowrap',
          border: 0,
          opacity: 0,
        },
      }}
    >
      <ImageInput
        {...props}
        accept={allowPdf ? OVERLAY_IMAGE_ACCEPT_WITH_PDF : OVERLAY_IMAGE_ACCEPT}
        removeIcon={() => (
          <span
            style={{
              display: 'inline-block',
              fontSize: '12px',
              fontWeight: 'bold',
              color: 'white',
              backgroundColor: theme.palette.error.main,
              borderRadius: '5px',
              padding: '2px 8px',
              whiteSpace: 'nowrap',
            }}
          >
            {translate('resources.overlays.text.replace_current')}
          </span>
        )}
        validateFileRemoval={async () => {

          openFilePicker();
          throw new Error('replace-instead-of-remove');

        }}
        options={{
          ...props.options,
          onDropRejected: (fileRejections, event) => {

            notify('resources.overlays.notifications.invalid_file_type', { type: 'warning' });
            props.options?.onDropRejected?.(fileRejections, event);

          },
        }}
      />
    </Box>
  );

};
